import { IconButton, TableContainer } from "@material-ui/core";
import MyButton from "components/MyButton";
import React, { memo, useEffect, useMemo, useState } from "react";
import DocumentsData from "./DocumentsData";
// import FinanceDrawer from "./Drawer";
import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import {
  Document,
  Image,
  Link,
  Note,
  PDFDownloadLink,
  PDFViewer,
  Page,
  StyleSheet,
  Svg,
  Text,
  View,
  pdf,
  usePDF,
} from "@react-pdf/renderer";
import downloadImg from "assets/icons/DownloadIcon.svg";
import { ReactComponent as ExportYahIcon } from "assets/icons/export_yah.svg";
import { ReactComponent as LetterYahIcon } from "assets/icons/letter_yah.svg";
import sortImg from "assets/icons/sort-able-svg.svg";
import { BsSortDown, BsSortUp } from "react-icons/bs";
import { ReactComponent as LineYahIcon } from "assets/icons/yah_line.svg";
import AlertDialog from "components/Dialog";
import NewDialog from "components/NewDialog/Dialog";
import Button from "components/button/Button";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import thousands from "thousands";
import FinanceService from "../../../../Lib/API/Finance";
import { MyCheckbox } from "../../../../components";
import ShareDocumentsModal from "../ShareDocumentsModal";
import ViewDocumentModal from "../ViewDocumentModal";
import "./theme.scss";

const DocumentsTable = ({
  filters,
  viewDocument,
  documentData,
  searchValue,
  startDate,
  endDate,
  dateRange,
  downloadPDF,
  sharePDF,
  fileData,
  file,
  closeNewTaxReport,
  closeNewStatementReport,
  closeCheck,
  dateFormet,
  setPage,
  page,
  viewDocumentHandler,
  downloadFileHandler,
  onStatusChange
}) => {
  const { push } = useHistory();
  const {state} = useLocation();
  const [openModal, setOpenModal] = React.useState(false);
  const [selectionModel /* setSelectionModel */] = React.useState([]);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [check, setCheck] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState([]);
  const [count, setCount] = useState();
  const [sortField, setSortField] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(false);
  const [openShareModal, setOpenShareModal] = React.useState(false);
  const [documentRow, setDocumentRow] = React.useState(null);
  const [downloadBulkLoading, setDownloadBulkLoading] = React.useState(false);
  const [switchType, setSwitchType] = React.useState("single-documents");
  const [openDownloadBulkModal, setOpenDownloadBulkModal] = React.useState(false);
  const [openConfirmAlert, setOpenConfirmAlert] = React.useState(false);
  const [documentId, setDocumentId] = React.useState(null);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const documentHandler = (row) => {
    setOpenShareModal(true);
    setDocumentRow(row);

  }
  const fetchMyAPI = async (e) => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    const filter_by = [
      "all",
      "statements",
      "tax reports",
      "invoices",
      "receipts",
    ];
    const body =
      filters.status == undefined
        ? startDate !== null
          ? {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            filter:
              startDate && endDate
                ? {
                  date: {
                    start: moment(startDate).format("MM/DD/YYYY"),
                    end: moment(endDate).format("MM/DD/YYYY"),
                  },
                }
                : {},
          }
          : searchValue !== ""
            ? { search: searchValue }
            : startDate !== null &&
              searchValue !==
              {
                ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
                search: searchValue,
                filter:
                  startDate && endDate
                    ? {
                      date: {
                        start: moment(startDate).format("MM/DD/YYYY"),
                        end: moment(endDate).format("MM/DD/YYYY"),
                      },
                    }
                    : {},
              }
              ? ""
              : sortField
                ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } }
                : null
        : searchValue !== ""
          ? {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            search: searchValue,
            filter: {
              type:
                filters.status == "tax reports"
                  ? "tax_report"
                  : filters.status == "statements"
                    ? "tax_statement"
                    : filters.status == "invoices"
                      ? "invoice"
                      : filters.status == "receipts"
                        ? "receipt"
                        : filter_by?.includes(filters.status) ? filters.status : undefined,
            },
          }
          : {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            filter: {
              type:
                filters.status == "tax reports"
                  ? "tax_report"
                  : filters.status == "statements"
                    ? "tax_statement"
                    : filters.status == "invoices"
                      ? "invoice"
                      : filters.status == "receipts"
                        ? "receipt"
                        : filter_by?.includes(filters.status) ? filters.status : undefined,

            },
          };


          const data = body ? body : {};
            
        
          if(state?.documentId) {
            data.filter = {
              ...data.filter,
              batchDocumentId: state?.documentId
            }
          }
    FinanceService.getAllDocuments(token, page + 1, 30, data)
      .then((res) => {
        const result = res?.payload?.data;
        setProductData(result);
        setCount(res?.payload?.pagination?.count);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        toastr.error("Error", err?.data?.message);
      });
  };


  const confirmDeleteDocumentHandler =async () => {
    if(deleteLoading || !documentId) return;
    setDeleteLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.deleteDocument(token, documentId).then((response) => {
      toastr.success("Document deleted successfully");
      fetchMyAPI();
    })
    .catch((error) => {
      toastr.error(error?.data?.message || "Something went wrong");
    }
    )
    .finally(() => {
      setOpenConfirmAlert(false);
      setDeleteLoading(false);
      setDocumentId(null);
    });
  }
  const deleteDocumentHandler = async (id) => {
    setOpenConfirmAlert(true)
    setDocumentId(id)
  }

useEffect(() => {
  if(!state?.documentType) return;
  if(state?.documentType === "tax_statement") {
    onStatusChange("Statements")
  } else if(state?.documentType === "tax_report") {
    onStatusChange("Tax Reports")
  }
}, [state?.documentType])

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   * @param {string} accountId
   */
  const onCheckboxChange = (e, row) => {
    const {
      _id,
      type
    } = row;
    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item.id !== _id);
        return [...checkClone];
      });
      return;
    }
    setCheck((prev) => [...prev, {
      id: _id,
      type: type
    }]);

  };


  const checkAllCurrentPageChecked = () => {
    if(!productData.length) return false;
    const productIds = productData.map((item) => item._id);
    const checkIds = check.map((item) => item.id);
    return productIds.every((id) => checkIds.includes(id));
  }


  const onCheckboxAllChange = (e) => {
    setCheckAll(e.target.checked);
    setCheck([]);
  }
  
  const getPayloadData = () => {
    const filter_by = [
      "all",
      "statements",
      "tax reports",
      "invoices",
      "receipts",
    ];
    const body =
      filters.status == undefined
        ? startDate !== null
          ? {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            filter:
              startDate && endDate
                ? {
                  date: {
                    start: moment(startDate).format("MM/DD/YYYY"),
                    end: moment(endDate).format("MM/DD/YYYY"),
                  },
                }
                : {},
          }
          : searchValue !== ""
            ? { search: searchValue }
            : startDate !== null &&
              searchValue !==
              {
                ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
                search: searchValue,
                filter:
                  startDate && endDate
                    ? {
                      date: {
                        start: moment(startDate).format("MM/DD/YYYY"),
                        end: moment(endDate).format("MM/DD/YYYY"),
                      },
                    }
                    : {},
              }
              ? ""
              : sortField
                ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } }
                : null
        : searchValue !== ""
          ? {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            search: searchValue,
            filter: {
              type:
                filters.status == "tax reports"
                  ? "tax_report"
                  : filters.status == "statements"
                    ? "tax_statement"
                    : filters.status == "invoices"
                      ? "invoice"
                      : filters.status == "receipts"
                        ? "receipt"
                        : filter_by?.includes(filters.status) ? filters.status : undefined,
            },
          }
          : {
            ...(sortField ? { sort: { [sortField]: sortDir === "asc" ? 1 : -1 } } : {}),
            filter: {
              type:
                filters.status == "tax reports"
                  ? "tax_report"
                  : filters.status == "statements"
                    ? "tax_statement"
                    : filters.status == "invoices"
                      ? "invoice"
                      : filters.status == "receipts"
                        ? "receipt"
                        : filter_by?.includes(filters.status) ? filters.status : undefined,

            },
          };


          const data = body ? body : {};
            
        
          if(state?.documentId) {
            data.filter = {
              ...data.filter,
              batchDocumentId: state?.documentId
            }
          }
          return data;
  }


  const bulkDownloadHandler = async () => {
    setDownloadBulkLoading(true)
    const token = await getAccessTokenSilently();
    const payload = getPayloadData();
    const documentsIds = checkAll ? ["all"] : check.map(item => item.id);
      FinanceService.downloadDocuments(token, { 
      ...payload,
      documentIds: documentsIds
     })
      .then((response) => {
        setOpenDownloadBulkModal(true);
      })
      .catch((err) => {
        toastr.error(err?.data?.message || "Error while downloading documents");
      })
      .finally(() => {
        setDownloadBulkLoading(false);
      });
  }

  const checkIsMultipleTypes = () => {
    const types = check.map((item) => item.type);
    return new Set(types).size > 1;
  }

  const getMultipleType = () => {
    const types = check.map((item) => item.type);
    if (types.length) return types[0];
    return "";
  }

  const modifyRowData = (row, item) => {
    const modified = { ...row, charge: { ...row.charge }, ...item };
    setDrawerData(modified);
    setOpenModal(true);
  };

  const handelSort = (field) => {
    if (sortField === field) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDir("asc");
    }
  };

  useEffect(() => {
    // if (searchValue || endDate !== null) setPage(0);
    setProductData([]);
    fetchMyAPI();

    window.addEventListener("save-transaction", fetchMyAPI);
    return () => {
      window.removeEventListener("save-transaction", fetchMyAPI);
    };
  }, [
    filters,
    page,
    getAccessTokenSilently,
    searchValue,
    dateRange,
    sortField,
    sortDir,
    closeNewTaxReport,
    closeNewStatementReport,
    closeCheck,
  ]);

  useEffect(() => {
    setPage(0);
  }, [filters?.status]);

  const handelBatchDownload = () => {
    productData.forEach(function (row) {
      console.log("row", row);
      documentData(row);
      downloadPDF(row?.type);
    });
  };

  const closeShareDocumentModal = (close = false) => {
    if(close) {
      setOpenShareModal(false);
      setDocumentRow(null);
      return;
    }
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenShareModal(false);
    setDocumentRow(null);
  }


  const [logoImage, setLogoImage] = useState(null);

  useEffect(() => {
    setLogoImage(localStorage?.getItem("Base64"));
  }, []);
  const styles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });

  const TaxReportStyles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    totalRowText: {
      width: "180px",
    },
    totalRowAmount: {
      width: "150px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });



  const TaxStatementPdf = ({ productData }) => {
    return (
      <Document id="divToPrint">
        {productData?.map((row) => {
          let address = {};
          if (row?.account_details?.addresses) {
            for (var i = 0; i < row?.account_details?.addresses?.length; i++) {
              if (row?.account_details?.addresses[i]?.billing) {
                address = {
                  city: row.account_details.addresses[i].city,
                  state: row.account_details.addresses[i].state,
                  zip_code: row.account_details.addresses[i].zip_code,
                  formattedAddress: `${row.account_details.addresses[
                    i
                  ].location?.formattedAddress?.split(",")[0]
                    } ${row.account_details.addresses[i].addressLine2
                      ? row.account_details.addresses[i].addressLine2
                      : ""
                    } `,
                };
              }
            }
          }

          let totalAmount = 0;
          for (let i = 0; i < row?.transaction.length; i++) {
            if (row?.transaction) {
              totalAmount += row?.transaction[i].total_amount;
            }
          }

          let totalAmountPaid = 0;
          for (let i = 0; i < row?.transaction.length; i++) {
            if (row?.transaction) {
              if (row?.transaction?.[i]?.total_paid) {
                if (row?.transaction?.[i]?.total_paid === null)
                  totalAmountPaid += 0;
                else {
                  totalAmountPaid += row?.transaction?.[i]?.total_paid;
                }
              } else {
                totalAmountPaid += 0;
              }
            }
          }

          let totalAmount_due = 0;
          for (let i = 0; i < row?.transaction.length; i++) {
            if (row?.transaction) {
              if (row?.transaction?.[i]?.amount_due) {
                if (row?.transaction?.[i]?.amount_due === null)
                  totalAmount_due += 0;
                else {
                  totalAmount_due += row?.transaction?.[i]?.amount_due;
                }
              } else {
                totalAmount_due += 0;
              }
            }
          }
          return (
            <Page style={styles.docMain} key={row?._id}>
              <View>
                <View style={styles.docoHead}>
                  <View style={styles.docOrgDetails}>
                    <View>
                      <Text style={styles.orgName}>
                        {row?.organization?.orgName}
                      </Text>
                      <Text style={styles.docOrgDetailsAddress}>
                        {row?.organization?.contactInfo?.address}
                      </Text>
                      <Text style={styles.docOrgDetailsPhone}>
                        {row.organization.contactInfo.phone}
                      </Text>
                    </View>
                    <View styles={styles.image}>
                      <Image src={logoImage} style={styles.logo} />
                    </View>
                  </View>
                </View>
                <View style={styles.docBody}>
                  <View style={styles.docoBodyHeading}>
                    <View style={styles.docoBodyHeadingHead}>
                      <Text style={styles.docoBodyHeadingHeadH1}>
                        Statement {row?.tax_id}
                      </Text>
                      {/* <Text style={styles.docoBodyHeadingHeadP}>
                    Tax ID {row?.tax_id}
                  </Text> */}
                    </View>
                    <View style={styles.dateDetails}>
                      <View style={styles.docoBodySubHead}>
                        <Text style={styles.docoBodySubHeadName}>
                          To: {row?.name}{" "}
                        </Text>
                        <Text style={styles.docoBodySubHeadDate}>
                          {moment(row?.createdAt)
                            .utcOffset("+0100")
                            .format("LL")}
                        </Text>
                      </View>
                      {/* <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      Balance: $ {thousands((+totalAmount_due).toFixed(2))}{" "}
                    </Text>
                  </View> */}
                      <View style={styles.docoBodySubHeadAddresses}>
                        <Text style={styles.docoBodySubHeadcity}>
                          {address?.formattedAddress}

                          {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                        </Text>
                        <Text style={styles.docoBodySubHeadcity}>
                          {address?.city}, {address?.state} {address?.zip_code}
                          {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                        </Text>
                        <Text style={styles.docoBodySubHeadZip}>
                          {row?.account_details?.zip_code}
                        </Text>
                        <Text style={styles.docoBodySubHeadPhone}>
                          {" "}
                          {row?.account_details?.admin_contact}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.outStandingMain}>
                    <Text style={styles.outStandingText}>
                      Outstanding balance: ${" "}
                      {thousands((+totalAmount_due).toFixed(2))} as of{" "}
                      {moment(row?.date.end).utcOffset("+0100").format("LL")}
                    </Text>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableHeading}>
                      <Text style={styles.tableHeadingText}>Payments</Text>
                    </View>
                    <View style={styles.HeaderRow}>
                      <Text style={styles.DateCol}>DATE</Text>
                      <Text style={styles.ChargeDetailCol}>CHARGE DETAILS</Text>
                      <Text style={styles.AmountCol}>AMOUNT</Text>
                      <Text style={styles.AmountPaidCol}>AMOUNT PAID</Text>
                      <Text style={styles.AmountDueCol}>AMOUNT DUE</Text>
                    </View>
                    {row?.transaction?.map((item, i) => {
                      return (
                        <View style={styles.BodyRow}>
                          <Text style={styles.DateCol}>
                            {moment(item?.date)
                              .utcOffset("+0100")
                              .format(dateFormet)}
                          </Text>
                          <Text style={styles.ChargeDetailCol}>
                            {item?.details?.Ledger?.name
                              ? item?.details?.Ledger?.name
                              : ""}
                            {item?.details?.SubLedger?.name ? "\n" : ""}
                            {item?.details?.SubLedger?.name
                              ? item?.details?.SubLedger?.name
                              : ""}

                            {item?.visible ? "\n" : ""}
                            {item?.visible ? item?.note : ""}
                          </Text>
                          <Text style={styles.AmountCol}>
                            {/* {getCommaSeperatedValue(item?.total_amount)} */}
                            ${" "}
                            {item?.total_amount
                              ? thousands((+item?.total_amount).toFixed(2))
                              : "0.00"}
                          </Text>
                          <Text style={styles.AmountPaidCol}>
                            {/* {getCommaSeperatedValue(item?.total_paid)} */}${" "}
                            {item?.total_paid
                              ? thousands((+item?.total_paid).toFixed(2))
                              : "0.00"}
                          </Text>
                          <Text style={styles.AmountDueCol}>
                            {/* {getCommaSeperatedValue(item?.amount_due)} */}${" "}
                            {item?.amount_due
                              ? thousands((+item?.amount_due).toFixed(2))
                              : "0.00"}
                          </Text>
                        </View>
                      );
                    })}
                  </View>
                  <View style={styles.totalRow}>
                    <Text style={styles.DateCol}>Total</Text>
                    <Text style={styles.ChargeDetailCol}> </Text>
                    <Text style={styles.AmountCol}>
                      {" "}
                      $ {thousands((+totalAmount).toFixed(2))}
                    </Text>
                    <Text style={styles.AmountCol}>
                      {" "}
                      $ {thousands((+totalAmountPaid).toFixed(2))}
                    </Text>
                    <Text style={styles.AmountCol}>
                      {" "}
                      $ {thousands((+totalAmount_due).toFixed(2))}
                    </Text>
                  </View>

                  <View style={styles.footer}>
                    {/* <View style={styles.footerBorder}></View> */}
                    <Text className="m-0">
                      Page 1 of 1 | Statement {row?.tax_id} | Created{" "}
                      {moment(row?.createdAt)
                        .utcOffset("+0100")
                        .format("LL h:mm A")}
                    </Text>
                  </View>
                </View>
              </View>
            </Page>
          );
        })}
      </Document>
    );
  };

  const TaxReportPdf = ({ productData }) => {
    return (
      <Document id="divToPrint">
        {productData?.map((row) => {
          let address = {};
          if (row?.account_details?.addresses) {
            for (var i = 0; i < row?.account_details?.addresses?.length; i++) {
              if (row?.account_details?.addresses[i]?.billing) {
                address = {
                  city: row.account_details.addresses[i].city,
                  state: row.account_details.addresses[i].state,
                  zip_code: row.account_details.addresses[i].zip_code,
                  formattedAddress: `${row.account_details.addresses[
                    i
                  ].location?.formattedAddress?.split(",")[0]
                    } ${row.account_details.addresses[i].addressLine2
                      ? row.account_details.addresses[i].addressLine2
                      : ""
                    } `,
                };
              }
            }
          }

          let totalElgAmount = 0;
          for (let i = 0; i < row?.transaction.length; i++) {
            if (row?.transaction) {
              totalElgAmount += row?.transaction[i].eligible_amount;
            }
          }
          let totalContAmount = 0;
          for (let i = 0; i < row?.transaction.length; i++) {
            if (row?.transaction) {
              totalContAmount += row?.transaction[i].contribution_amount;
            }
          }
          return (
            <Page style={TaxReportStyles.docMain} key={row?._id}>
              <View>
                <View style={TaxReportStyles.docoHead}>
                  <View style={TaxReportStyles.docOrgDetails}>
                    <View>
                      <Text style={TaxReportStyles.orgName}>
                        {row?.organization?.orgName}
                      </Text>
                      <Text style={TaxReportStyles.docOrgDetailsAddress}>
                        {row?.organization?.contactInfo?.address}
                      </Text>
                      <Text style={TaxReportStyles.docOrgDetailsPhone}>
                        {row.organization.contactInfo.phone}
                      </Text>
                    </View>
                    <View>
                      <Image src={logoImage} style={TaxReportStyles.logo} />
                    </View>
                  </View>
                </View>
                <View style={TaxReportStyles.docBody}>
                  <View style={TaxReportStyles.docoBodyHeading}>
                    <View style={TaxReportStyles.docoBodyHeadingHead}>
                      <Text style={TaxReportStyles.docoBodyHeadingHeadH1}>
                        Tax Report {row?.tax_id}
                      </Text>
                      {/* <Text style={TaxReportStyles.docoBodyHeadingHeadP}>
                        Tax ID {row?.tax_id}
                      </Text> */}
                    </View>
                    <View style={TaxReportStyles.dateDetails}>
                      <View style={TaxReportStyles.docoBodySubHead}>
                        <Text style={TaxReportStyles.docoBodySubHeadName}>
                          To: {row?.name}{" "}
                        </Text>
                        <Text style={TaxReportStyles.docoBodySubHeadDate}>
                          {moment(row?.createdAt)
                            .utcOffset("+0100")
                            .format("LL")}
                        </Text>
                      </View>
                      {/* <View style={styles.docoBodySubHead}>
                        <Text style={styles.docoBodySubHeadName}>
                          Balance: {row?.account_details?.balance ?? "0"}{" "}
                        </Text>
                      </View> */}
                      <View style={TaxReportStyles.docoBodySubHeadAddresses}>
                        <Text style={styles.docoBodySubHeadcity}>
                          {address?.formattedAddress}
                        </Text>
                        <Text style={styles.docoBodySubHeadZip}>
                          {address?.city}, {address?.state} {address?.zip_code}
                        </Text>
                        <Text style={TaxReportStyles.docoBodySubHeadPhone}>
                          {" "}
                          {row?.account_details?.admin_contact}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={TaxReportStyles.outStandingMain}>
                    <Text style={TaxReportStyles.outStandingText}>
                      Payment made from{" "}
                      {moment(row?.date.start).utcOffset("+0100").format("LL")}{" "}
                      to:&nbsp;
                      {moment(row?.date.end).utcOffset("+0100").format("LL")}
                    </Text>
                  </View>
                  <View style={TaxReportStyles.table}>
                    <View style={TaxReportStyles.tableHeading}>
                      <Text style={TaxReportStyles.tableHeadingText}>
                        Payments
                      </Text>
                    </View>
                    <View style={TaxReportStyles.HeaderRow}>
                      <Text style={TaxReportStyles.ChargeDetailCol}>
                        CHARGE DETAILS
                      </Text>
                      <Text style={TaxReportStyles.AmountCol}>
                        ELIGIBLE AMOUNT
                      </Text>
                      <Text style={TaxReportStyles.AmountDueCol}>
                        CONTRIBUTION AMOUNT
                      </Text>
                    </View>
                    {row?.transaction?.map((item, i) => {
                      return (
                        <View style={TaxReportStyles.BodyRow}>
                          <Text style={TaxReportStyles.ChargeDetailCol}>
                            {item.Ledger?.name ? item.Ledger?.name : ""}
                          </Text>
                          <Text style={TaxReportStyles.AmountCol}>
                            {/* ${getCommaSeperatedValue(item?.eligible_amount)} */}
                            ${" "}
                            {item?.eligible_amount
                              ? thousands((+item?.eligible_amount).toFixed(2))
                              : "0.00"}
                          </Text>
                          <Text style={TaxReportStyles.AmountPaidCol}>
                            {/* ${getCommaSeperatedValue(item?.contribution_amount)} */}
                            ${" "}
                            {item?.contribution_amount
                              ? thousands(
                                (+item?.contribution_amount).toFixed(2)
                              )
                              : "0.00"}
                          </Text>
                        </View>
                      );
                    })}
                  </View>
                  <View style={TaxReportStyles.totalRow}>
                    <Text style={TaxReportStyles.totalRowText}>Total</Text>
                    <Text style={TaxReportStyles.totalRowAmount}>
                      {" "}
                      {/* ${getCommaSeperatedValue(totalElgAmount)} */}${" "}
                      {totalElgAmount
                        ? thousands((+totalElgAmount).toFixed(2))
                        : "0.00"}
                    </Text>
                    <Text style={TaxReportStyles.totalRowAmount}>
                      {" "}
                      {/* ${getCommaSeperatedValue(totalContAmount)} */}${" "}
                      {totalContAmount
                        ? thousands((+totalContAmount).toFixed(2))
                        : "0.00"}
                    </Text>
                  </View>

                  <View style={TaxReportStyles.footer}>
                    {/* <View style={TaxReportStyles.footerBorder}></View> */}
                    <Text className="m-0">
                      Page 1 of 1 | Statement {row?.tax_id} | Created{" "}
                      {moment(row?.createdAt)
                        .utcOffset("+0100")
                        .format("MMMM Do, YYYY h:mm A")}
                    </Text>
                  </View>
                </View>
              </View>
            </Page>
          );
        })}
      </Document>
    );
  };

 const isLimitReached = useMemo(() => {
    return checkAll ? count > 500 : check.length > 500;
  }
  ,[checkAll, count, check])



  return (
    <div className="w-100">
      <div className="family-table-container p-7 pb-15">
        <div className="home-table-container mt-0 no-box-shadow">
          <div className="yah-sub d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between mb-5 h-40px">
              <div
                className="d-flex align-items-center"
                style={{
                  height: "36px",
                  backgroundColor: "#e7edf9",
                  borderRadius: "4px",

                }}
              >
                <button
                  type="button"
                  onClick={() => {
                    setPage(0);
                    onStatusChange("All");
                    setSwitchType("single-documents");
                    setCheck([]);
                    fetchMyAPI();
                  }}
                  className={
                    switchType === "single-documents"
                      ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                      : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                  }
                  style={
                    switchType === "single-documents"
                      ? { color: "#FFFFFF", height: "24px" }
                      : { color: "#2555EF", height: "24px" }
                  }
                  disabled={loading}

                >
                  Single Documents
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setSwitchType("bulk-documents");
                    onStatusChange("All");
                    push({
                      pathname: "/finance/batch-documents",
                    });
                  }}
                  className={
                    switchType === "bulk-documents"
                      ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                      : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                  }
                  style={
                    switchType === "bulk-documents"
                      ? { color: "#FFFFFF", height: "24px" }
                      : { color: "#2555EF", height: "24px" }
                  }
                >
                  Bulk Documents
                </button>
              </div>
            </div>


            <div className="options">
              {(check?.length || checkAll) ? (
                <>
                  <Tooltip 
                    title={"Document limit is 500; apply filters to create smaller list."}
                    disableHoverListener={!isLimitReached}
                  >
                  <Button
                    variant="secondary-light"
                    onClick={() => {
                      if(isLimitReached) return;
                      bulkDownloadHandler();
                    }}
                    size="md"
                    disabled={downloadBulkLoading}
                    style={{ minWidth: "118px"}}
                  >
                    {downloadBulkLoading ? (
                      <div className="d-flex">
                        <CircularProgress size={22}
                          style={{
                            color: "#2555ef",

                          }}
                        />
                      </div>
                    ) : (
                      <>
                        <ExportYahIcon className="" /> 
                        <span>Download</span>
                      </>
                    )}
                  </Button>
                  </Tooltip>
                  <LineYahIcon className="mx-5" />
                  <Tooltip 
                    title={"Document limit is 500; apply filters to create smaller list."}
                    disableHoverListener={!isLimitReached}
                  >
                    <Button
                      variant="secondary-light"
                      onClick={() => {
                        if(isLimitReached) return;
                        setOpenShareModal(true)
                      }}
                      size="md"
                    >
                      <LetterYahIcon className="" />
                      <span>
                        Send Letter: {checkAll ? count : check.length}
                      </span>
                    </Button>
                  </Tooltip>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <br />

          {/* <MyButton
            buttonTextStyle={{
              margin: 0,

              paddingBlock: 4.3,
            }}
            type={"primary"}
            content={
              <div className="new-charge-button mx-5">
                <span>Download {productData?.length}</span>
              </div>
            }
            onClick={handelBatchDownload}
            /> */}
          {/* <div className="w-100 text-right">

            <PDFDownloadLink
              document={<TaxStatementPdf productData={productData} />}
              fileName="TaxStatements.pdf"
            >
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : `Download ${productData?.length}`
              }
            </PDFDownloadLink>

            </div> */}

          {/* <div className="new-charge-button mx-5">
                        <span className="plus-icon">+</span>
                        <span>Tax Report</span>
                      </div> */}

          {/* <IconButton size="large" onClick={handelBatchDownload}>
            <img src={downloadImg} alt="download" />
          </IconButton> */}
          <TableContainer component={Paper} className="scroll-table">
            <Table className="charges-table">
              <TableHead className="main-table__header sticky-table-header">
                <TableRow>
                  <TableCell padding="checkbox">
                    <MyCheckbox name={"bulk-share"} handlechange={(e) => {
                      onCheckboxAllChange(e)
                    }}
                      checked={checkAll}
                    />
                  </TableCell>
                  {filters?.status !== undefined ? (
                    <>
                      <TableCell
                        align="left"
                        className="first-cell"
                        style={{ width: 250 }}
                      >
                        ACCOUNT NAME
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          width: 300,
                        }}
                      >
                        TYPE
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell
                        align="left"
                        style={{
                          width: 300,
                        }}
                      >
                        TYPE
                      </TableCell>
                      <TableCell
                        align="left"
                        className="first-cell"
                        style={{ width: 250 }}
                      >
                        ACCOUNT NAME
                      </TableCell>
                    </>
                  )}

                  {filters?.status?.toLowerCase() === "statements" && (
                    <TableCell align="center" style={{ width: 230 }}>
                      AMOUNT
                    </TableCell>
                  )}
                  <TableCell align="center" style={{ width: 410 }}>
                    DATE / DATE RANGE
                    <IconButton onClick={() => handelSort("date")}>
                      {sortField === "date" ? (sortDir === "asc" ? <BsSortUp /> : <BsSortDown />) : <img src={sortImg} alt="sort" />}
                    </IconButton>
                  </TableCell>
                  <TableCell align="center" style={{ width: 200 }}>
                    CREATED DATE
                    <IconButton onClick={() => handelSort("createdAt")}>
                      {sortField === "createdAt" ? (sortDir === "asc" ? <BsSortUp /> : <BsSortDown />) : <img src={sortImg} alt="sort" />}
                    </IconButton>
                  </TableCell>
                  <TableCell align="center" style={{ width: 300 }}>
                    LAST SENT
                  </TableCell>
                  <TableCell align="left" className="sticky-header-column"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody className="doc-table-body">
                {productData.length == 0 ? (
                  loading == true ? (
                    <div className="doco-loader">
                      <Loader />
                    </div>
                  ) : (
                    <td colSpan={12}>
                      <div className="record-text">No record found</div>
                    </td>
                  )
                ) : loading == true ? (
                  <div className="doco-loader">
                    <Loader />
                  </div>
                ) : (
                  productData?.map((row) => (
                    <DocumentsData
                      modifyRowData={modifyRowData}
                      key={row?._id}
                      row={row}
                      page={page}
                      setPage={setPage}
                      onCheckboxChange={onCheckboxChange}
                      check={check}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      filters={filters}
                      viewDocument={viewDocument}
                      documentData={documentData}
                      downloadPDF={downloadPDF}
                      sharePDF={sharePDF}
                      fileData={fileData}
                      file={file}
                      documentHandler={documentHandler}
                      viewDocumentHandler={viewDocumentHandler}
                      downloadFileHandler={downloadFileHandler}
                      deleteDocumentHandler={deleteDocumentHandler}
                      checkAll={checkAll}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {productData?.length === 0 ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / 30)}
                color="primary"
                page={page + 1}
                variant="outlined"
                onChange={(event, value) => {
                  let page = value - 1;
                  setPage(page);
                  // setCheck([]);
                }}
              />
            </div>
          )}
        </div>
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        ></RightDrawer>
        <Dialog
          open={openShareModal}
          onClose={() => closeShareDocumentModal()}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ShareDocumentsModal
            closeModal={closeShareDocumentModal}
            documentsIds={checkAll ? ["all"] : check?.length ? check.map(item => item.id) : [documentRow?._id]}
            documentType={check?.length ? getMultipleType() : documentRow?.type}
            defaultEmail={documentRow?.account_details?.defaultEmails || []}
            isMultiple={checkAll || check?.length !== 0}
            isMultipleTypes={checkAll || checkIsMultipleTypes()}
            type="Document"
            payload={getPayloadData()}
          />
        </Dialog>
        {openDownloadBulkModal &&
          <NewDialog
            isOpen={openDownloadBulkModal}
            handleClose={() => {
              setOpenDownloadBulkModal(false);
            }}
            title={"Download Bulk Documents"}
            content={<p>{"Once the documents are ready, an email confirmation will be sent to you"}</p>}
          >
            <button
              className="download-bulk__modal-btn"
              onClick={() => {
                setOpenDownloadBulkModal(false);
              }}
            >
              Ok
            </button>
          </NewDialog>
        }
        <AlertDialog
          open={openConfirmAlert}
          onDecline={() => {
            setOpenConfirmAlert(false);
          }}
          onAccept={() => {
            confirmDeleteDocumentHandler()
          }}
          content={`Are you sure?`}
          disabled={deleteLoading}
        />
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </div>
  );
};

export default memo(DocumentsTable);
